import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import { JOURNAL_LEVEL } from '@/utils/dict'
import journal from '@/api/journal'
import help from '../../../../utils/help'
import { settingJournalLanguage } from '@/api/setting'

export default {
  data() {
    return {
      params: {
        languageId: 'Default',
        details: {},
      },
      rules: {},
      colors: [
        '#5157A6',
        '#B85F84',
        '#EA762A',
        '#B83D26',
        '#359DD8',
        '#2EA5A6',
      ],
      personalColor: '',
      isJournal: false,
      isEdit: true,
      editId: '',
      keywords: [],
      level: JOURNAL_LEVEL,
      indexedDatabase: {
        Clarivate: 'Clarivate',
        PubMed: 'PubMed',
        Scopus: 'Scopus',
      },
      urlAddress: '', // 复制文件地址
      languages: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      journalId: 'getJournalId',
    }),
  },
  watch: {
    journalId: {
      handler(val) {
        this.getJournal(val)
      },
      immediate: true,
    },
  },
  mounted() {
    this.isJournal = this.$route.path.includes('/journals/')
    this.isEdit = !this.$route.path.includes('/add/')
    if (this.isJournal) {
      this.editId = this.$route.params.id
      this.getJournal(this.editId)
    }
    this.getRules()
    this.getLanguages()
  },
  methods: {
    async getLanguages(){
     this.languages = await settingJournalLanguage.getAll({journalId: this.journalId})
    },
    async handleUpload(key, files) {
      const file = files[0]
      const imgFiles = ['logo', 'cover']
      const pdfFiles = ['authorGuide', 'openAccessLink', 'publishingAgreement']
      const imgTypes = ['image/jpeg', 'image/png']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      } else if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType,
        })
        return false
      }
      const MS = 20
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB',
        })
        return false
      }
      this.loading = true
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/journal/${this.params.id}`,
        file.name
      )
      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail,
        })
        return false
      }
      this.loading = false

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage(val, name) {
      help.download(val, name)
    },

    async submit(val) {
      const flag = this.$refs['journal-basic-information-form'].validate()
      this.params.keyword = this.params.keywords
        ? this.params.keywords.join(';')
        : ''
      if (this.params.keyword.length > 2048) {
        this.$message.error({
          title: 'Error',
          content: 'The keyword exceeds the maximum length (2048 words)!',
        })
        return
      }
      if (this.params.languageId==='Default'){
        this.params.languageId=null
      }
      if (flag) {
        const data = Object.assign(this.params, {
          released: val,
        })
        if (this.params.id) {
          await journal.edit(this.params.id, data)
          this.$message.success({
            title: 'Success',
            content: 'This Journal has been published!',
          })
        } else {
          await journal.add(data)
          if (val) {
            this.$message.success({
              title: 'Success',
              content: 'This Journal has been published!',
            })
          } else {
            this.$message.success({
              title: 'Success',
              content: 'This Journal has been saved!',
            })
          }
        }
        if (this.isJournal) {
          this.$router.push('/publishing/journals')
        }
        this.getJournal(this.journalId)
      }
    },
    preview() {},
    async getJournal(val) {
      if (!val) {
        return
      }
      const data = await journal.query(val)
      if (!this.colors.includes(data.mainColor)) {
        this.personalColor = data.mainColor
      }
      if (!data.languageId){
        data.languageId = 'Default'
      }
      data.keywords = data.keyword ? data.keyword.split(';') : []
      this.params = data
    },
    getRules() {
      this.rules = {
        // logo: [
        //   {
        //     required: true,
        //     message: 'Journal Logo' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        fullName: [
          {
            required: true,
            message:
              'Journal’s Full Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        name: [
          {
            required: true,
            message:
              'Journal’s Abbreviation' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        nameDatabase: [
          {
            required: true,
            message:
              'Journal’s Abbreviation (Database)' +
              this.LANGUAGE[this.language].noEmpty,
          },
        ],
        contactEmail: [
          {
            required: true,
            message: 'Contact Email' + this.LANGUAGE[this.language].noEmpty,
          },
          {
            type: 'email',
            message:
              this.LANGUAGE[this.language].enterCorrent + 'Contact Email',
          },
        ],
        cover: [
          {
            required: true,
            message: 'Journal Cover' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        info: [
          {
            required: true,
            message: 'Introduction' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        authorGuide: [
          {
            type: 'website',
            message:
              this.LANGUAGE[this.language].enterCorrent + 'Author Guideline',
          },
        ],
        openAccessLink: [
          {
            type: 'website',
            message:
              this.LANGUAGE[this.language].enterCorrent +
              'Open Access Permission',
          },
        ],
        publishingAgreement: [
          {
            required: true,
            message: 'Publishing Policy' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        submitLink: [
          {
            required: true,
            message: 'Submit URL' + this.LANGUAGE[this.language].noEmpty,
          },
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Submit Link',
          },
        ],
        reviewLink: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Submit Link',
          },
        ],
        impactFactorUrl: [
          {
            type: 'website',
            message:
              this.LANGUAGE[this.language].enterCorrent + 'Impact Factor URL',
          },
          {
            max: 256,
            message: 'Impact Factor URL cannot be more than 32 digits!',
          },
        ],
        fiveImpactFactorUrl: [
          {
            type: 'website',
            message:
              this.LANGUAGE[this.language].enterCorrent +
              '5 Years Impact Factor URL',
          },
          {
            max: 256,
            message: '5 Years Impact Factor URL cannot be more than 32 digits!',
          },
        ],
        citationScoreUrl: [
          {
            type: 'website',
            message:
              this.LANGUAGE[this.language].enterCorrent + 'CiteScore URL',
          },
          {
            max: 256,
            message: 'CiteScore URL cannot be more than 32 digits!',
          },
        ],
        mainColor: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].themeColor +
              this.LANGUAGE[this.language].noEmpty,
          },
        ],
        // issn: [
        //   {
        //     required: true,
        //     message: 'ISSN' + this.LANGUAGE[this.language].noEmpty,
        //   },
        // ],
        wordTemplate: [
          {
            required: true,
            message: 'Word Template' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        latexTemplate: [
          {
            required: true,
            message: 'Latex Template' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        impactFactor: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        fiveImpactFactor: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        citationScore: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        decisionDay: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        receiveDay: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        buildTime: [
          {
            min: 1000,
            max: 2999,
            message: 'Please enter the correct year',
          },
        ],
        reviewDeadline: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        revisionDeadline: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
        specialBufferDay: [
          {
            min: 0,
            message: 'Please enter a positive integer',
          },
        ],
      }
    },
    // Copy File Address
    handleCopyAddress(val) {
      this.urlAddress = this.domain + '/' + val
      help.copyToBlock(this.urlAddress)
      this.$message.success({
        title: 'Success',
        content: 'The File Address has been copied to the clipboard!',
      })
    },
  },
}
